import React from 'react';
import PropTypes from 'prop-types';

import PopupFilter from './popupFilter';
import { Select } from 'semantic-ui-react';

/**
 * Abstraction for a basic select filter
 */
export default class SelectFilter extends React.Component {
    constructor(props) {
        super(props);

        let query = this.props.query();

        this.state = {
            value: query[this.props.name] || null
        };

        if (this.props.setClearer) {
            this.props.setClearer(() => this.clear(false));
        }
    }

    onChange(name, value, options) {
        let option = options.find(opt => opt.value === value);

        this.setState(
            {
                value: option.text
            },
            () => {
                // Set value in url
                this.props.addToQuery(name, value);
                this.props.onChange(name, value);
            }
        );
    }

    clear(triggerEvents = true) {
        this.setState(
            {
                value: null
            },
            () => {
                this.props.removeFromQuery(this.props.name);
                if (triggerEvents) {
                    this.props.onChange(this.props.name);
                    this.props.onClear(this.props.name);
                }
            }
        );
    }

    render() {
        let { label, options, name } = this.props;

        let buttonProps = {};

        if (this.state.value) {
            buttonProps = {
                label: this.state.value,
                basic: false
            };
        }

        return (
            <PopupFilter label={label} buttonProps={buttonProps} clear={this.clear.bind(this)} value={this.state.value}>
                <Select placeholder={label} value={this.state.value} options={options} onChange={(synth, { value, options }) => this.onChange(name, value, options)} />
            </PopupFilter>
        );
    }
}

SelectFilter.defaultProps = {
    onChange: () => {},
    onClear: () => {},
    label: '',
    options: [],
    name: '',
    query: () => ({}),
    removeFromQuery: () => {},
    addToQuery: () => {}
};

SelectFilter.propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    options: PropTypes.array,
    name: PropTypes.string,
    setClearer: PropTypes.func,
    query: PropTypes.func,
    removeFromQuery: PropTypes.func,
    addToQuery: PropTypes.func
};
